import { render, staticRenderFns } from "./billDetails.vue?vue&type=template&id=19ee6a00&scoped=true&"
import script from "./billDetails.vue?vue&type=script&lang=js&"
export * from "./billDetails.vue?vue&type=script&lang=js&"
import style0 from "./billDetails.vue?vue&type=style&index=0&id=19ee6a00&prod&lang=scss&scoped=scoped&"
import style1 from "./billDetails.vue?vue&type=style&index=1&id=19ee6a00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ee6a00",
  null
  
)

export default component.exports